import {
  DEFAULT_THEME
} from "./chunk-5UTBCMBA.mjs";

// src/theme-provider/utils.ts
import { isFn } from "@julo-ui/function-utils";
function generateColorsCssVar(colors) {
  const keys = Object.keys(colors);
  let result = "";
  for (const key of keys) {
    const innerKeys = Object.keys(colors[key]);
    for (const innerKey of innerKeys) {
      result += `--colors-${key}-${innerKey}: ${colors[key][innerKey]};`;
    }
  }
  return result;
}
function generateCommonCssVar(prefixKey, object) {
  const keys = Object.keys(object);
  let result = "";
  for (const key of keys) {
    result += `--${prefixKey}-${key}: ${object[key]};`;
  }
  return result;
}
var extendsTheme = (theme) => {
  if (isFn(theme))
    theme = theme(DEFAULT_THEME);
  const defaultThemeKeys = Object.keys(DEFAULT_THEME);
  const defaultThemeVals = defaultThemeKeys.reduce(
    (prevThemeVals, currentKey) => ({
      ...prevThemeVals,
      [currentKey]: {
        ...DEFAULT_THEME[currentKey],
        ...theme[currentKey]
      }
    }),
    {}
  );
  return {
    ...theme,
    ...defaultThemeVals
  };
};

export {
  generateColorsCssVar,
  generateCommonCssVar,
  extendsTheme
};
